import { render, staticRenderFns } from "./MonatsabschlussEditContextMenu.vue?vue&type=template&id=6dd8bb1a&"
import script from "./MonatsabschlussEditContextMenu.vue?vue&type=script&lang=ts&"
export * from "./MonatsabschlussEditContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports